import type { IterableLike } from "../types/IterableLike"
import { is_mapping } from "./is_mapping"
import { to_array } from "./to_array"

/**
 * Checks if iterable contains element.
 *
 * For objects, checks key existence. For arrays/primitives, checks value presence.
 *
 * @param iterable - Container to search
 * @param element - Element to find (value for arrays, key for objects)
 * @returns True if found
 *
 * @example
 * ```ts
 * import { contains } from "@pdfking/rfunc"
 *
 * contains([1, 2, 3], 2) // true
 * contains({ a: 1 }, "a") // true
 * ```
 */
export const contains = <T>(
  iterable: IterableLike<T>,
  element: T | string
): boolean => {
  if (is_mapping(iterable)) {
    return (element as string) in iterable
  }
  return to_array(iterable).indexOf(element as T) > -1
}
